<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @selection-change="handleSelectionChange" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="KqTerminalId" label="终端标识" width="">
        </el-table-column>
        <el-table-column prop="TerminalName" label="终端名称" width="">
        </el-table-column>
        <el-table-column prop="DepartmentName" label="所属部门" width="">
        </el-table-column>
        <el-table-column prop="TerminalDesc" label="备注" width="">
        </el-table-column>
        <el-table-column prop="TouchTypeDirection" label="撤销密码" width="">
        </el-table-column>
        <el-table-column prop="CreateTime" label="添加时间">
        </el-table-column>
      </el-table>
      </div>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10"
          :total="total" style="float: right">
        </el-pagination>
      </el-col>
      <!--编辑界面-->
      <el-dialog title="编辑终端信息" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false"
        destroy-on-close>
        <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">

          <el-form-item label="终端标识" prop="KqTerminalId">
            <el-input v-model="editForm.KqTerminalId" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="终端名称" prop="TerminalName">
            <el-input v-model="editForm.TerminalName" auto-complete="off"></el-input>
          </el-form-item>

          <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->

          <el-form-item label="撤销密码" prop="TouchTypeDirection">
            <el-input v-model="editForm.TouchTypeDirection" auto-complete="off"
              @input="editForm.TouchTypeDirection = editForm.TouchTypeDirection.replace(/[^\d]/g, '')"></el-input>
          </el-form-item>

          <el-form-item label="设备说明">
            <el-input type="textarea" v-model="editForm.TerminalDesc"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增终端信息" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false"
        destroy-on-close>
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm" class="demo-form-inline">

          <el-form-item label="终端标识" prop="KqTerminalId">
            <el-input v-model="addForm.KqTerminalId" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="终端名称" prop="TerminalName">
            <el-input v-model="addForm.TerminalName" auto-complete="off"></el-input>
          </el-form-item>

          <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->

          <el-form-item label="撤销密码" prop="TouchTypeDirection">
            <el-input v-model="addForm.TouchTypeDirection" auto-complete="off"
              @input="addForm.TouchTypeDirection = addForm.TouchTypeDirection.replace(/[^\d]/g, '')"></el-input>
          </el-form-item>

          <el-form-item label="设备说明">
            <el-input type="textarea" v-model="addForm.TerminalDesc"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

    </section>

  </section>

</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getKqtDeviceTerminalListPage, removeKqtDeviceTerminal, editKqtDeviceTerminal, addKqtDeviceTerminal } from '../../api/modules/attendance';
import { getTeachingDepartmentTree } from '../../api/modules/department';
import { BaseApiUrl } from '../../api/base';
import { syucUser } from '../../api/modules/consumption';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import es from "@/lang/es";

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '终端名称',
          key: 'name',
        },
        {
          label: '序列号',
          key: 'kqTerminalId',
          placeholder: '终端标识/序列号'
        },
      ],
      users: [],
      roles: [],
      options: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        KqTerminalId: [
          { required: true, message: "请输入终端标识", trigger: "blur" },
        ],
        TerminalName: [{ required: true, message: "请输入终端名称", trigger: "blur" }],
        TouchTypeDirection: [
          { required: true, message: '请输入撤销密码', trigger: 'blur' },
          { pattern: /^\d+$/, message: '撤销密码只能是数字', trigger: 'blur' }
        ],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        KqTerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "",
        TerminalDesc: "",
        Dids: [],
        DepartmentId: 0,
        TerminalTypeId: "5",
      },
      isResouceShow: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        KqTerminalId: [
          { required: true, message: "请输入终端标识", trigger: "blur" },
        ],
        TerminalName: [{ required: true, message: "请输入终端名称", trigger: "blur" }],
        TouchTypeDirection: [
          { required: true, message: '请输入撤销密码', trigger: 'blur' },
          { pattern: /^\d+$/, message: '撤销密码只能是数字', trigger: 'blur' }
        ],
      },
      //新增界面数据
      addForm: {
        KqTerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "",
        TerminalDesc: "",
        Dids: [],
        DepartmentId: 0,
        TerminalTypeId: "5",
      },
      DepartmentId: 0,
      currentUserId: '',
      imageUrl: '',
      imageLoadding: false,
      multipleSelection: [],
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    beforeAvatarUpload(file) {
      // 这里可以过滤不要的文件
      this.imageLoadding = true
      return true
    },

    //头像上传成功
    handleAvatarSuccess(res, file) {
      this.imageLoadding = false
      console.log(res)
      this.imageUrl = res.response
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
      let para = {
        id: this.DepartmentId,
      };
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
        type: "5"
      }
      this.listLoading = true;

      testapi();
      //NProgress.start();
      getKqtDeviceTerminalListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {

      var rows = this.multipleSelection

      if (rows.length == 0 || rows.length > 1) {
        this.$message({
          message: '请选择要删除的一行数据！',
          type: 'error',
        })
        return
      }

      var row = rows[0];

      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removeKqtDeviceTerminal(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示编辑界面
    handleEdit() {

      var rows = this.multipleSelection

      if (rows.length == 0 || rows.length > 1) {
        this.$message({
          message: '请选择一行数据进行编辑！',
          type: 'error',
        })
        return
      }

      var row = rows[0];

      this.options = [];

      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      // 优先使用当前终端绑定的所属学校ID，若无则使用当前页面统一选中的 ID 兜底
      this.editForm.DepartmentId = row.DepartmentId || this.DepartmentId;
    },
    //显示新增界面
    handleAdd() {
      // 限制：必须先在左侧选择具体的学校机构才能进行新增
      if (!this.DepartmentId || this.DepartmentId === '0' || this.DepartmentId === 0) {
        this.$message.warning("请先在左侧选择具体的学校机构！");
        return;
      }
      this.addFormVisible = true;
      this.options = [];
      this.addForm = {
        KqTerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "",
        TerminalDesc: "",
        Dids: [],
        DepartmentId: this.DepartmentId, // 直接使用当前页面统一选中的学校ID
        TerminalTypeId: "5"
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            editKqtDeviceTerminal(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.options = [];
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);

            addKqtDeviceTerminal(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.options = [];
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
    handleSyucUser() {
      var rows = this.multipleSelection

      if (rows.length == 0) {
        this.$message({
          message: '至少选择一个设备进行下发！',
          type: 'error',
        })
        return
      }

      if (rows.length > 5) {
        this.$message({
          message: '最多只能选择五个设备！',
          type: 'error',
        })
        return
      }

      let arr = [];
      rows.forEach(e => {
        arr.push(e.KqTerminalId)
      })

      let para = {
        deviceNos: arr,
        way: '0'
      };

      this.$confirm("确认进行下发吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          syucUser(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "下发成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => { });

      console.log(this.multipleSelection);
    },
    handleDelUser() {
      var rows = this.multipleSelection

      if (rows.length == 0) {
        this.$message({
          message: '至少选择一个设备操作！',
          type: 'error',
        })
        return
      }

      if (rows.length > 5) {
        this.$message({
          message: '最多只能选择五个设备！',
          type: 'error',
        })
        return
      }

      let arr = [];
      rows.forEach(e => {
        arr.push(e.KqTerminalId)
      })

      let para = {
        deviceNos: arr,
        way: '2'
      };

      this.$confirm("确认进行清空人员吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          syucUser(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => { });

      console.log(this.multipleSelection);
    }
  },
  mounted() {

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
/* .custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
} */

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}
</style>
